exports.filedRules = () => {
    return {
        required: (value) => !!value || `필수입력입니다.`, //${filed} is
        counter: (value) => value && value.length >= 3 || `Please enter at least 3 characters`,
    }
};
exports.requiredRule = value => {
    return !!value || "Required.";
};
exports.ko_requiredRule = value => {
    return !!value || "필수 입력 정보입니다.";
};

exports.requiredRuleByItem = (text) => (value) => {
  return !!value || `${text}은/는 필수 입력 정보입니다.`;
};

exports.moreCounterRuleByLength = (len) => (value) => {
  return value && value.length > len || (len +"글자 이상 입력해주세요");
};

exports.lessCounterRuleByLength = (len) => (value) => {
  return value && value.length < len || (len +"글자 이내로 입력해주세요");
};

exports.tagRules = () => {
    return {
        required: (value) => !!value || "태그를 입력해주세요.",
        counter: (value) => value && value.length <= 10 || "최대 10자로 입력해주세요",
    }
};
exports.eligibleRules = () => {
    return {
        required: (value) => !!value || "This is required",
        counter: (value) => value && value.length < 1 || "Please enter a value greater than at least 0",
    }
};
exports.declarationRules = () => {
    return {
        required: (value) => !!value || "신고사유를 입력해주세요.",
        counter: (value) => value && value.length > 5 || "최소 5자이상으로 입력해주세요",
    }
};
exports.SSNRules = () => {
    return {
        required: (value) => !!value || "SSN is Required",
        counter: (value) => value && value.length > 8 || "SSN must be 8 digits long",
        check: (value) => {
            const pattern = /^\d+$/;
            return pattern.test(value) || "Only numbers are allowed";
        },
    }
};
exports.idRules = () => {
    return {
        required: (value) => !!value || "로그인아이디는 필수입니다.",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "로그인아이디는 이메일 형식입니다.";
        },
    }
};
exports.emailRules = () => {
    return {
        required: (value) => !!value || "이메일주소는 필수입니다.",
        counter: (value) => value && value.length <= 100 || "Max 100 characters",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "이메일 형식을 확인해주세요.";
        },
    }
};
exports.loginIdRules = () => {
    return {
        required: (value) => !!value || "아이디(휴대폰 번호)로 넣어주세요",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "로그인아이디는 이메일 형식입니다.";
        },
    }
};

exports.loginPasswordRules = () => {
    return {
        required: (value) => !!value || "비밀번호를 입력해주세요",
        counter: (value) =>
            value && (value.length >= 8 && value.length <= 20) ||
            "8-20자리로 입력해 주세요",
        check: (value) => {
          let num = /[0-9]/.test(value);
          let engCap = /[A-Z]/.test(value);
          let eng = /[a-z]/.test(value);
          let spe = /[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/.test(value);

          let count = [num, engCap, eng, spe].filter(v => v).length;

          return count > 2 || "영문 대문자, 영문 소문자, 숫자, 특수문자 중 3가지 이상 포함하여 입력해 주세요.";
        }
    }
};

exports.emailIdRules = () => {
    return {
        check: (value) => {
            const pattern = /^[a-zA-Z0-9!@#$%^&*?_.]+$/;
            return pattern.test(value); // || "영문 대소문자, 특수문자, 숫자로 입력해주세요";
        },
    }
};

exports.passwordRules = () => {
    return {
        required: (value) => !!value || "비밀번호는 필수입니다.",
        counter: (value) =>
            value && (value.length >= 8 && value.length <= 20) ||
            "8-20자리로 입력해 주세요",
        check: (value) => {
          let num = /[0-9]/.test(value);
          let engCap = /[A-Z]/.test(value);
          let eng = /[a-z]/.test(value);
          let spe = /[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/.test(value);

          let count = [num, engCap, eng, spe].filter(v => v).length;

          return count > 2 || "영문 대문자, 영문 소문자, 숫자, 특수문자 중 3가지 이상 포함하여 입력해 주세요.";
        }
    }
};

exports.cellRules = () => {
    return {
        required: (value) => !!value || "휴대폰번호는 필수입력입니다.",
        counter: (value) => value && value.length > 8 && value.length < 12 || "올바른 휴대폰번호를 입력해주세요",
        min: (value) => value && value.length > 8 || "올바른 휴대폰번호를 입력해주세요",
        max: (value) => value && value.length < 12 || "올바른 휴대폰번호를 입력해주세요",
        check: (value) => {
            const pattern =
                /^(01[016789]{1})[0-9]{3,4}[0-9]{4}$/g;
            return pattern.test(value) || "올바른 휴대폰번호를 입력해주세요";
        },
        patternCounter: (value) => value && value.length > 8 && value.length < 14 || "올바른 휴대폰번호를 입력해주세요",
        checkPattern: (value) => {
            const pattern =
                /^(01[016789]{1})[0-9]{3,4}[0-9]{4}$/g;
            return pattern.test(value) || "올바른 휴대폰번호를 입력해주세요";
        },
    }
};
exports.nameRules = () => {
    let reData = {
        required: (value) => !!value || "성함을 입력해 주세요",
        counter: (value) => value && value.length >= 2 && value.length <= 10 || "성함은 2 글자 이상 10 글자 이하 이어야 합니다",
        check: (value) => {
            const pattern = /^[ㄱ-ㅎ가-힣]+$/;
            return pattern.test(value) || "성함에 특수기호와 숫자, 영문은 입력할 수 없습니다.";
        },
    }
    return reData;
};

exports.daysOfWeek = () => {
    let reData = ["일", "월", "화", "수", "목", "금", "토"];
    return reData;
};
exports.monthName = () => {
    let reData = [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
    ];
    return reData;
};
exports.s3Config = () => {
    let reData = {
        S3_BUCKET: 'zplabpublic',
        S3_REGION: 'ap-northeast-2',
        S3_POOLID: 'ap-northeast-2:cae44641-b6f1-4893-9615-3ef9523f732a',
        // S3_UPLOAD_ROOT: 'bayerFarm'
    }
    return reData;
};
